var __jsx = React.createElement;
import React from "react";
import { twMerge } from "tailwind-merge";
var TabSelector = function TabSelector(_ref) {
  var tabs = _ref.tabs,
    activeTab = _ref.activeTab,
    onTabChange = _ref.onTabChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white p-1 rounded shadow-[0_0_4px_0_rgba(102,102,102,0.08)] flex items-center gap-1 w-fit"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(TabButton, {
      key: tab.key,
      tab: tab,
      isActive: activeTab === tab.key,
      onClick: function onClick() {
        return onTabChange(tab.key);
      }
    });
  }));
};
var TabButton = function TabButton(_ref2) {
  var tab = _ref2.tab,
    isActive = _ref2.isActive,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClick,
    className: twMerge("px-2 py-1 rounded bg-white text-[#6C7A8D] text-xs font-medium cursor-pointer md:min-w-[250px] md:py-3 md:text-center md:text-base", isActive && "bg-primary-old text-white font-semibold")
  }, tab.value);
};
export default TabSelector;